import { ItemWithLabel } from '@innovyze/stylovyze';
import React from 'react';

import { useGlobalization } from '@Translations/useGlobalization';
import { IntegrationType } from '../../../../types/integration.types';

const integrationTypesMap: Record<IntegrationType, string> = {
	[IntegrationType.ArcGis]: 'ArcGIS Online',
	[IntegrationType.Vapar]: 'VAPAR',
	[IntegrationType.ITPipes]: 'ITPipes',
};

export const IntegrationsTypeWithLabel = ({
	integrationType: status,
}: {
	integrationType: IntegrationType;
}) => {
	const { t } = useGlobalization();
	const type = integrationTypesMap[status];

	return <ItemWithLabel label={t('Integration Type')} value={t(type)} />;
};
